import { rd } from '@passionware/monads';
import { useMemo } from 'react';
import { getCalloutSlugFieldPrefix } from 'v5/api/callouts/callout-slug.logic';
import { WithServices } from 'v5/platform/ts/services';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';

type UseCalloutPublicUrlPrefixServices = WithServices<
  [WithAppScopeService, WithEnterpriseService]
>['services'];

export function useCalloutPublicUrlPrefix(
  services: UseCalloutPublicUrlPrefixServices,
  workspaceId?: number | null
): string {
  const organizationId = services.appScopeService.useOrganizationId();
  const workspaceRd = services.enterpriseService.useWorkspace(
    organizationId,
    workspaceId
  );
  const enterpriseWorkspaceSlug = rd.tryMap(
    workspaceRd,
    workspace => workspace?.slug
  );

  return useMemo(
    () => getCalloutSlugFieldPrefix(enterpriseWorkspaceSlug),
    [enterpriseWorkspaceSlug]
  );
}
